'use client';

import clsx from 'clsx';
import { Heading2 } from '@/components/section/headings';
import { WindowAccordionSlider, type WindowAccordionSlide } from '@/components/widget';
import { PAGE_SECTION_BAND_MUTED, pageSectionShell } from '@/constants/pageSections';

export type MarketingHubCarouselSectionProps = {
  title: string;
  subtitle?: string;
  slides: readonly WindowAccordionSlide[];
  className?: string;
};

/** Full-width hover accordion band — sits below the hub hero, before category links. */
export default function MarketingHubCarouselSection({
  title,
  subtitle,
  slides,
  className,
}: MarketingHubCarouselSectionProps) {
  return (
    <section
      className={clsx(
        pageSectionShell(PAGE_SECTION_BAND_MUTED),
        'page-accordion-section',
        className
      )}
      aria-labelledby="hub-carousel-heading"
    >
      <div className="page-content-grid">
        <div className="page-accordion-section__heading" id="hub-carousel-heading">
          <Heading2
            title={title}
            subtitle={subtitle}
            titleClassName="text-prose"
            subtitleClassName="mt-2 text-prose-muted"
          />
        </div>
        <WindowAccordionSlider slides={slides} />
      </div>
    </section>
  );
}

MarketingHubCarouselSection.displayName = 'MarketingHubCarouselSection';
